import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './IconLibrary.css';

function IconLibrary({ icons, activeIcon, setActiveIcon, handleUpdate}) {
    const { t } = useTranslation('assistantConfiguration');
    const carouselRef = useRef(null); // Referência para o container do carrossel
    const iconSize = 60; // Largura aproximada de cada ícone
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    // Atualiza os estados de scroll para saber se pode avançar ou voltar
    const updateScrollState = () => {
        if (carouselRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
        }
    };

    // Detecta rolagem manual e ajusta os estados
    useEffect(() => {
        const carousel = carouselRef.current;
        if (!carousel) return;

        carousel.addEventListener("scroll", updateScrollState);
        updateScrollState(); // Inicializa os estados corretamente

        return () => carousel.removeEventListener("scroll", updateScrollState);
    }, []);

    useEffect(() => {
        if (activeIcon && carouselRef.current) {
            const iconIndex = Object.keys(icons).indexOf(activeIcon);
            if (iconIndex !== -1) {
                carouselRef.current.scrollLeft = iconIndex * iconSize; // Movimenta até a posição correta
            }
        }
    }, [activeIcon]);
    

    // Função para avançar os ícones
    const nextIcon = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollLeft += iconSize;
        }
    };

    // Função para retroceder os ícones
    const prevIcon = () => {
        if (carouselRef.current) {
            carouselRef.current.scrollLeft -= iconSize;
        }
    };

    return (
        <div className='biblioteca-icon'>
            {/* Botão de seta esquerda */}
            <img
                src="/imagens/left-arrow.svg"
                onClick={canScrollLeft ? prevIcon : null} // Só permite clique se puder rolar
                className={`arrow-icon ${!canScrollLeft ? 'disabled' : ''}`} // Aplica estilo de desativado
                alt={t('previousArrowLabel')}
            />

            {/* Contêiner fixo do carrossel */}
            <div className="icon-carousel-container" ref={carouselRef}>
                <div className="icon-carousel">
                    {Object.keys(icons).map((iconKey, index) => (
                        <div
                            key={index}
                            className="icon-item"
                            data-testid="icon-item"
                            onClick={() => {
                                setActiveIcon(iconKey);
                                handleUpdate("assistant", "icon", icons[iconKey]());
                            }}
                        >
                            <div className={`biblioteca-ellipse ${iconKey === activeIcon ? "active" : ""}`}>
                                <div className='center-icon'
                                    dangerouslySetInnerHTML={{
                                        __html: icons[iconKey](
                                            iconKey === activeIcon ? "#FFFFFF" : "#0067FF"
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Botão de seta direita */}
            <img
                src="/imagens/right-arrow.svg"
                onClick={canScrollRight ? nextIcon : null} // Só permite clique se puder rolar
                className={`arrow-icon ${!canScrollRight ? 'disabled' : ''}`} // Aplica estilo de desativado
                alt={t('nextArrowLabel')}
            />
        </div>
    );
}

export default IconLibrary;
